import { a11yProps, EstadoTransitoInventarioENUM, ROUTER_PATHS, texto, useTabsFormOnly } from "@/shared";
import { CustomTabPanel, FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import TransferenciaInventarioEsperaPage from "./shared/componente/transferencia-inventario-espera/TransferenciaInventarioEsperaPage";
import { useNavigate } from "react-router-dom";
import TablaTransferenciaInventarioComponente from "./shared/componente/table_transferencia_inventario/TablaTransferenciaInventarioComponente";
import { EstadoSolicitudTransferencia } from "@/shared/interfaces";
import MoveDownIcon from '@mui/icons-material/MoveDown';
import TablaTransTransitoInventario from "./shared/componente/table_transito_inventario/TablaTransTransitoInventario";
import TableTransitoTransferenciaInventario from "../revision_transferencia_inventario/shared/table_transito_transferencia_inventario/TableTransitoTransferenciaInventario";
import { TableNotificacionInventario } from "../notificacion-inventario";

export default function TransferenciaInventarioPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 0
  });

  const navigate = useNavigate();

  return (
    <SingleTableBoxScene title="📦Transferencia de Inventario"
      enableCreateOrEditBtn={true}
      textCreateOrEditBtn={'Crear una Transferencia'}
      iconCreateOrEdit={<MoveDownIcon />}
      fnCreateOrEdit={() => {
        navigate(ROUTER_PATHS.inventario.trasladoInventarioIngresoNav);
      }}
    >

      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label={texto.finalizado} value={0} {...a11yProps(1)} />
          <Tab label={'En Espera'} value={1} {...a11yProps(2)} />
          <Tab label={'En Transito'} value={2} {...a11yProps(3)} />
          <Tab label={'Técnico'} value={3} {...a11yProps(4)} />
          <Tab label={texto.solicitud} value={4} {...a11yProps(0)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

 
      
      {/*traslado-inventario*/}
      <CustomTabPanel index={valueTab} value={0}>
        <TablaTransferenciaInventarioComponente
          estado={EstadoSolicitudTransferencia.FINALIZADO}
        />
      </CustomTabPanel>

      {/*transito inventario*/}
      <CustomTabPanel index={valueTab} value={1}>
        <TablaTransTransitoInventario
          estado_solicitud={EstadoTransitoInventarioENUM.EN_ESPERA}
        />
      </CustomTabPanel>
      
      {/*transito inventario*/}
      <CustomTabPanel index={valueTab} value={2}>
        <TableTransitoTransferenciaInventario
          estado_transito={EstadoTransitoInventarioENUM.EN_TRANSITO}
          enable_action={true}
        />
      </CustomTabPanel>

      {/*tecnico*/}
      <CustomTabPanel index={valueTab} value={3}>
        <TableNotificacionInventario modulo="INVENTARIO" />
      </CustomTabPanel>

      {/*solicitud-traslado*/}
      <CustomTabPanel index={valueTab} value={4}>
        <TransferenciaInventarioEsperaPage />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}


